import React from 'react'
import { graphql } from 'gatsby'
import { Container, Col, Row } from 'reactstrap'

import SiteDocumentations from '../../../components/SiteDocumentations'

import SEO from '../../../components/seo'

import EzFlo from './ezflo.png'

class ezflo extends React.Component {
  render() {
    const seoData = {
      title: "Documentation produits d'irrigation Ez-Flo",
      description: "Consultez notre documentation des produits d'irrigation Ez-Flo",
      coverImage: EzFlo,
      path: this.props.location.pathname,
      schemaOrg: ''
    }

    return (
      <div>
        <SEO seoData={seoData} />
        <Container>
          <Row style={{alignItems: "center", marginBottom: 20}}>
            <Col lg={2} md={2} xs={6}>
              <img src={EzFlo} alt="Ez-Flo"/>
            </Col>
            <Col lg={10} md={10} xs={12}><h1>Manuels d’instruction Ez-Flo</h1></Col>
          </Row>
          <SiteDocumentations {...this.props} />
        </Container>
      </div>
    )
  }
}

export default ezflo

export const ezfloDocumentationQuery = graphql`
  query EzFloDocumentation {
    site {
      meta: siteMetadata {
        title
        description
        url: siteUrl
        author
      }
    }
    remark: allMarkdownRemark(
      filter: { frontmatter: { vendor: { eq: "EzFlo" } } }
    ) {
      documentations: edges {
        documentation: node {
          id
          html
          frontmatter {
            layout
            title
            path
            coverImage {
              childImageSharp {
                fluid(maxWidth: 400) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
    }
  }
`
